<template>
    <div>
        <div class="exit-edit-btn" 
        @click="exitEdit" v-if="editMode">Kurti naują nuorodą</div>
        <div class="edit-container">
            <form class="link-form">
                <label>Vardas Pavardė: </label>
                <input class="name" v-model="name"/>
                <label>Įmonė: </label>
                <input class="business" v-model="business"/>

                <label>Originalus linkas: </label>
                <input class="original-link" v-model="originalLink"/>

                <label>Galiojimo laikas</label>
                <div class="date-picker-container">
                    <date-picker
                        required
                        v-model="date"
                        @input="unlimitedTime = false"
                        label="date"
                        :placeholder="toLocal('users_side.select_date')"
                        :class="['invitation-date-picker', { 'grayed-out': unlimitedTime }]"
                        type="date"
                        valueType="format"
                    >
                    </date-picker>
                    Arba
                    <div class="unlimited-time" @click="setUnlimitedTime" :class="{ active: unlimitedTime }">Neribotai</div>
                </div>
                <div class="add-link-btn" @click="generateLink">{{editMode ? 'Išsaugoti nuorodą' : 'Generuoti nuorodą'}}</div>
            </form>
        </div>
        <div class="links-list">
            <h3>Visos Nuorodos</h3>
            <table class="links-table" :key="tableKey">
                <thead>
                    <tr>
                        <th>Vardas pavardė</th>
                        <th>Įmonė</th>
                        <th>Galioja iki</th>
                        <th>Nuoroda</th>
                        <th>Originali nuoroda</th>
                        <th>Veiksmai</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(link, index) in generatedLinks" :key="index">
                        <td>{{ link.name }}</td>
                        <td>{{ link.business }}</td>
                        <td>{{ link.expiration_date }}</td>
                        <td><a :href="link.link" target="_blank">{{ link.link }}</a></td>
                        <td><a :href="link.original_link" target="_blank">{{ link.original_link }}</a></td>
                        <td>
                            <button class="edit-btn" @click="editLink(link, index)">Redaguoti</button>
                            <button class="delete-btn" @click="deleteLink(link, index)">Pašalinti</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from 'axios';

export default {
    components:{
        DatePicker
    },
    data(){
        return {
            name: null,
            business: null,
            date: null,
            link: null,
            unlimitedTime: false,
            generatedLinks: [],
            originalLink: null,
            newLink: null,
            editMode: false,
            editableIndex: -1,
            tableKey: false,
        }
    },
    mounted(){
        this.getAllLinks();
    },
    methods: {
        exitEdit(){
            this.resetFields();
        },
        editLink(link, index){
            this.name = link.name;
            this.business = link.business;
            this.date = link.expiration_date;
            this.originalLink = link.original_link;
            this.editableIndex = index;
            this.newLink = link.link;
            this.linkEditId = link.id;
            this.editMode = true;
        },
        async getAllLinks(){
            axios.get(`${this.$store.state.api_link}/get-all-links`, {
                }, this.$store.getters.axiosConfig()).then((res) => {
                    this.generatedLinks = res.data.links;
                });
        },
        resetFields(){
            this.name = null;
            this.business = null;
            this.date = null;
            this.originalLink = null;
            this.newLink = null;
            this.editableIndex = -1;
            this.unlimitedTime = false;
            this.linkEditId = null;
            this.editMode = false;
            this.tableKey = !this.tableKey;
        },
        async generateLink() {
            if(this.editMode){
                axios.post(`${this.$store.state.api_link}/update-link`, {
                    id: this.linkEditId,
                    name: this.name,
                    business: this.business,
                    date: this.unlimitedTime ? null : this.date,
                    original_link: this.originalLink,
                    link: this.newLink,
                }, this.$store.getters.axiosConfig()).then((res) => {
                    console.log(res.data.link);
                    this.generatedLinks[this.editableIndex] = res.data.link;
                    this.resetFields();
                    this.getAllLinks();
                })
            }else{
                axios.post(`${this.$store.state.api_link}/generate-link`, {
                    name: this.name,
                    business: this.business,
                    date: this.unlimitedTime ? null : this.date,
                    original_link: this.originalLink,
                }, this.$store.getters.axiosConfig()).then((res) => {
                    console.log(res.data.link);
                    this.newLink = res.data.link.link;
                    this.generatedLinks.push(res.data.link);
                });
            }
        },
        setUnlimitedTime() {
            this.unlimitedTime = true;
            this.date = null;
        },
        deleteLink(link, index) {
            axios.post(`${this.$store.state.api_link}/delete-link`, {
                link: link.id,
            }, this.$store.getters.axiosConfig())
            this.generatedLinks.splice(index, 1);
            this.tableKey = !this.tableKey;
        }
    }
}
</script>

<style lang="scss" scoped>
.link-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    padding: 16px;
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    background-color: #f8f8f8;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.link-form label {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 4px;
}

.link-form input {
    padding: 8px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;
    background-color: #ffffff;
    color: #333333;
    transition: border-color 0.3s;
}

.link-form input:focus {
    border-color: #666666;
    outline: none;
}

.date-picker-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.add-link-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    border-radius: 4px;
    background-color: #333333;
    color: #ffffff;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.05s ease;
}

.add-link-btn:hover {
    background-color: #444444;
    transform: scale(1.01);
}

.unlimited-time {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 12px;
    border-radius: 4px;
    background-color: #555555;
    color: #ffffff;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.05s ease;
}

.unlimited-time:hover {
    background-color: #666666;
    transform: scale(1.01);
}

.unlimited-time.active {
    background-color: #444444;
    color: #ffffff;
}

.invitation-date-picker.grayed-out {
    background-color: #f0f0f0;
    opacity: 0.9;
    pointer-events: auto;
    cursor: pointer;
}

.links-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 16px;
}

.links-table th, .links-table td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
}

.links-table th {
    background-color: #f4f4f4;
    font-weight: bold;
}

.links-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.edit-btn, .delete-btn {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    margin-right: 4px;
}

.edit-btn {
    background-color: #333333;
    color: #ffffff;
}

.edit-btn:hover {
    background-color: #444444;
}

.delete-btn {
    background-color: #dc3545;
    color: #ffffff;
}

.exit-edit-btn{
    background-color: #dc3545;
    color: #ffffff;
    display: flex;
    width: fit-content;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer; 
}

.exit-edit-btn:hover{
    background-color: #a71d2a;
}

.delete-btn:hover {
    background-color: #a71d2a;
}
</style>